import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonRouterOutlet, IonContent, IonHeader, IonButton } from "@ionic/angular/standalone";
import { Router } from '@angular/router';

import { inject } from '@angular/core';
import { CcrrList } from "../communities/pages/ccrr-list/ccrr-list";
import { UserDropdownComponent } from '@net3-multiplatform-client/libs';
import { AuthService } from '../auth/services/auth.service';

@Component({
  selector: 'ccrr-list-layout',
  imports: [
    CommonModule,
    RouterModule, 
    CcrrList,
    UserDropdownComponent
  ],
  templateUrl: './ccrr-list-layout.component.html'
})

export class CCRRListLayout {

  private authService = inject(AuthService);
  router = inject(Router);


  constructor() {}


  goComunnitie(community: any) {
    this.router.navigate(['/communities', community.schema_id]);
  }

  onSignOut(){
    this.authService.logout();
  }

}
